

export const read_cookie = (name: string): string| undefined | null => {


    const escapedName = name.replace(/([.*+?^${}()|[\]\\])/g, '\\$1');
    const cookieValue = document.cookie.match(new RegExp(`(?:^|; )${escapedName}=([^;]*)`));

    if (cookieValue) {
        try {
            const [, value] = cookieValue;
            return decodeURIComponent(value); // Decode the cookie value
        } catch (error) {
            console.error(`Error reading the '${name}' cookie:`, error);
        }
    } else {
        console.warn(`Cookie '${name}' not found.`);
    }

    return null;
};

export const bake_cookie = (name: string, value: string | number) => {
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 1);
    const domain = window.location.hostname;

    document.cookie = [
        `${name}=${value}`,
        `domain=${domain}`,
        'path=/',
        `expires=${expirationDate.toUTCString()}`,
    ].join('; ');
};

export const delete_cookie = (name: string) => {
    const domain = window.location.hostname;
    document.cookie =
        name +
        "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=" +
        domain +
        "; path=/;";
};
